import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { Button, rem } from 'design-system';
import { useAppDispatch } from 'store/hooks';
import { transferProductLater } from 'features/invest/actions';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import ProgressCard from './ProgressCard';
import { blockInvestOnboardingOnWeb } from '../../webGate';
const strings = {
    title: 'Transfer your existing ISA',
    desc: 'Keep your tax-free benefits. Bring your ISAs to Emma and manage everything in one place',
};
const TransferExistingProductProgressCard = ({ status }) => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const isActiveStep = status === 'ACTIVE';
    const handleTransfer = React.useCallback(() => {
        if (blockInvestOnboardingOnWeb())
            return;
        navigation.navigate('ProductTransferIntro');
    }, []);
    const handleLater = React.useCallback(() => {
        dispatch(transferProductLater());
    }, [dispatch]);
    return (<ProgressCard lightBg lastItem completed={false} title={strings.title} isActiveStep={isActiveStep}>
      <Text TextThin-14 Secondary>
        {strings.desc}
      </Text>
      {!!isActiveStep && (<>
          <Spacer h={16}/>
          <View style={styles.row}>
            <Button brandLight hug extra square title="Transfer ISA" onPress={handleTransfer}/>
            <Button brandBorder hug extra square title="Later" onPress={handleLater}/>
          </View>
        </>)}
    </ProgressCard>);
};
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        gap: rem(10),
    },
});
export default TransferExistingProductProgressCard;
